
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom';
import "./caseStudy.css"
import { AllcaseStudys } from '../../actions/caseStudyAction';
import CaseStudyCard from '../../components/caseStudyCard/CaseStudyCard';
const AllCaseStudy = () => {
  const [pageNumber, setPageNumber] = useState(0)
  const { allcaseStudy, loading } = useSelector((state) => state.caseStudyState)
  const dispatch = useDispatch()



  useEffect(() => {
    dispatch(AllcaseStudys)
  }, [dispatch])




  const userPerPage = 6
  const pageVisited = pageNumber * userPerPage

  const displayUsers = allcaseStudy ? allcaseStudy.slice(pageVisited, pageVisited + userPerPage).map((val) => {
    return <CaseStudyCard key={val._id} val={val} />
  }) : ""
  const pageCount = allcaseStudy ? Math.ceil(allcaseStudy.length / userPerPage) : ""

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }
  return (
    !allcaseStudy?.length ? <div className='no_blog_div'>no blogs</div> :
      <div style={{marginTop:"40px"}}>
         <Link to={"/create-case-study"} className='Create_caseS-btn'>Create Case-Study</Link>
        <div className='Card_section'>
         
          {
            loading ? "Loading...." : allcaseStudy ? displayUsers : allcaseStudy
          }
          {allcaseStudy ?
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBtns"}
              previousLinkClassName={"previousBtn"}
              nextLinkClassName={"nextBtn"}
              disabledClassName={"paginationDisable"}
              activeClassName={"paginationActive"}
            />
            : ""
          }
        </div>
      </div>

  )
}
export default AllCaseStudy
